<template>
  <v-list-item class="mb-0 justify-space-between pl-3">
    <v-list-item-avatar>
      <v-img
        src="
          https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTtVdHFTK3DEqWN7wDZCkdUr_ozYPUdDh800w&usqp=CAU'
        "
      />
    </v-list-item-avatar>

    <v-list-item-content class="pl-2">
      <v-list-item-title class="text-h3">
        <strong class="font-weight-black">C-</strong>
        <span class="primary--text">Cloud</span>
      </v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
// Utilities
import { get } from "vuex-pathify";

export default {
  name: "DefaultDrawerHeader",

  computed: { version: get("app/version") }
};
</script>
